module.exports = require('./helpers/bundle-url').getBundleURL('aBKVY') + "logo.7718c6df.svg";